__turbopack_context__.v({
  "figcaption": "Image-module__Nc_hnG__figcaption",
  "figure": "Image-module__Nc_hnG__figure",
});
